export default "/Frontend/dist/fallback-black.ca205789a9a54468e489b6c262fcde57.svg";